import React from 'react';
import PropTypes from 'prop-types';
import { getText } from 'src/utils/i18n';
import { Icon, Balloon } from '@alifd/next';
import IcbuIcon from '@alife/bc-icbu-icon';
import './index.scss';

const TA_LINK = '//tradeassurance.alibaba.com/?tracelog=from_detail_learnmore';

class TA extends React.Component {
  static propTypes = {
    baoAccountIsDisplayAssurance: PropTypes.bool,
    i18n: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  render() {
    const { props } = this;

    const { baoAccountIsDisplayAssurance, i18n } = props;

    if (!baoAccountIsDisplayAssurance) return null;
    if (this.state.hasError) {
      // 你可以自定义降级后的 UI 并渲染
      return <h1>Something went wrong.</h1>;
    }
    const elTa = (
      <div className="assurance-item item-ta">
        <a
          className="assurance-link"
          target="_blank"
          rel="noopener noreferrer"
          href={TA_LINK}
        >
          <IcbuIcon
            className="ta-link-item icon-ta"
            type="trade-assurance"
            size="small"
          />
          <span className="ta-link-item ta-title">
            {getText(
              i18n,
              'details_assurance_educate.text_brief_ta',
              'Trade Assurance',
            )}
          </span>
          <span className="ta-link-item ta-desc">
            {getText(
              i18n,
              'details_assurance_educate.text_brief_ta_protection',
              'protects your Alibaba.com orders',
            )}
          </span>
        </a>
      </div>
    );

    // return elTa;

    return (
      <Balloon
        className="assurance-educate-balloon"
        trigger={elTa}
        align="bl"
        cache
        alignEdge
        closable={false}
      >
        <div className="assurance-educate-tip">
          <div className="tip-text">
            {getText(
              i18n,
              'details_assurance_educate.taTipText',
              `Alibaba.com's built-in order protection service which protects online orders when payment is made through Alibaba.com.`,
            )}
            <a className="tip-text-more" href={TA_LINK} target="_blank">
              {getText(
                i18n,
                'details_assurance_educate.learnmore',
                'Learn More',
              )}
            </a>
          </div>
          <div className="tip-ta-text">
            <div className="ta-text-title">
              {getText(
                i18n,
                'details_assurance_educate.taEnsures',
                'Trade Assurance reduces risks in:',
              )}
            </div>
            <div className="ta-text-icons">
              <span className="icon-item">
                <Icon className="tip-icon" type="ProductQuality" />
                {getText(
                  i18n,
                  'details_assurance_educate.productQuality',
                  'Product Quality',
                )}
              </span>
              <span className="icon-item">
                <Icon className="tip-icon" type="On-TimeShipment" />
                {getText(
                  i18n,
                  'details_assurance_educate.ontimeShip',
                  'On-Time Shipment',
                )}
              </span>
            </div>
          </div>
        </div>
      </Balloon>
    );
  }
}

export default TA;
